import React from 'react';
import './about.css'
import { MDBContainer,  MDBRow, MDBCol,MDBBtn,MDBIcon} from "mdbreact";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter,Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { hasValue } from "../../validations/validations";
import { message,Spin,TreeSelect } from "antd";
import { UploadOutlined } from '@ant-design/icons';

const { TreeNode } = TreeSelect;
const { SHOW_PARENT } = TreeSelect;
class About extends React.Component {
    state = {
        imgType:'url',
        actionType:"EDIT",
        aboutUs_en:'',
        aboutUs_ar:'',
        newFeatures:'',
        inputCount:1,
        deleteInput1:false,
        deleteInput2:false,
        link1:'',
        social1:null,
        link2:'',
        social2:null,
        link3:'',
        social3:null,
        link4:'',
        social4:null,
        link5:'',
        social5:null,
        link6:'',
        social6:null,
        about:[],
        imgName:'',
        loading:true,
        img:null,
        selectedFile: null,
        socials:[]
    };

    constructor(props){
        super(props)
        window.scrollTo(0,0)
        if(this.props.isRTL){
            allStrings.setLanguage('ar')
        }else{
            allStrings.setLanguage('en')
        } 
    }

    componentDidMount(){
        this.getAbout()
        this.getSocialWithoutPagenation()
        if(this.props.isRTL){
            allStrings.setLanguage('ar')
        }else{
            allStrings.setLanguage('en')
        } 
    }
    /**
     * get Socials request
    */
    getSocialWithoutPagenation = () =>{
      let url = `${BASE_END_POINT}social/withoutPagenation/get`

      axios.get(url,{
        headers:{
          'Authorization':`Bearer ${this.props.currentUser.token}`,
          'Accept-Language':this.props.isRTL?'ar':'en'
        }
      })
      .then(response=>{
        console.log("socials   ",response.data)
  
         this.setState({socials:response.data.data})
      })
      .catch(error=>{
        console.log("error   ",error.response)
        console.log("error2   ",error)
      })
    }
    /**
     * get about request
    */
    getAbout = () =>{
        this.setState({loading:true})
        axios.get(`${BASE_END_POINT}about`,{
          headers:{
            'Authorization':`Bearer ${this.props.currentUser.token}`,
            'Accept-Language':this.props.isRTL?'ar':'en'
          }
        })
        .then(response=>{
          console.log("about   ",response.data.data)
          this.setState({
            loading:false,
            about:response.data.data,
            img:response.data.data.logo,
            aboutUs_ar:response.data.data.aboutUs_ar,
            aboutUs_en:response.data.data.aboutUs_en,
            socialMedia:response.data.data.socialMedia,
            inputCount:response.data.data.socialMedia.length,
            newFeatures:response.data.data.newFeatures?response.data.data.newFeatures:"",
            link1:response.data.data.socialMedia[0]?response.data.data.socialMedia[0].link:'',
            social1:response.data.data.socialMedia[0]?response.data.data.socialMedia[0].social.id:null,
            link2:response.data.data.socialMedia[1]?response.data.data.socialMedia[1].link:'',
            social2:response.data.data.socialMedia[1]?response.data.data.socialMedia[1].social.id:null,
            link3:response.data.data.socialMedia[2]?response.data.data.socialMedia[2].link:'',
            social3:response.data.data.socialMedia[2]?response.data.data.socialMedia[2].social.id:null,
            link4:response.data.data.socialMedia[3]?response.data.data.socialMedia[3].link:'',
            social4:response.data.data.socialMedia[3]?response.data.data.socialMedia[3].social.id:null,
            link5:response.data.data.socialMedia[4]?response.data.data.socialMedia[4].link:'',
            social5:response.data.data.socialMedia[4]?response.data.data.socialMedia[4].social.id:null,
            link6:response.data.data.socialMedia[5]?response.data.data.socialMedia[5].link:'',
            social6:response.data.data.socialMedia[5]?response.data.data.socialMedia[5].social.id:null,
           
          })
        })
        .catch(error=>{
          console.log("error   ",error.response)
          console.log("error2   ",error)
          this.setState({loading:false,})
        })
    }
    /**
     * update about request
    */
    update = () => {
        const {newFeatures,aboutUs_en,aboutUs_ar,imgType,img,social1,social2,social3,social4,social5,social6,link1,link2,link3,link4,link5,link6} = this.state
        
        if(hasValue(aboutUs_ar)&&hasValue(aboutUs_en)){
            let l = message.loading('Wait..', 2.5)
            var data = new FormData()
            data.append('aboutUs_en',aboutUs_en)
            data.append('aboutUs_ar',aboutUs_ar)
            data.append('newFeatures',newFeatures)
            if(img != null && imgType === "data"){
              data.append('logo',img); 
            }
            let socialMedia=[]
            if(link1 !=='' && social1 !==null ){
              socialMedia.push({
                  "link":link1,
                  "social":social1
                })
            }
            if(link2 !=='' && social2 !==null ){
              socialMedia.push({
                  "link":link2,
                  "social":social2
                })
            }
            if(link3 !=='' && social3 !==null ){
              socialMedia.push({
                  "link":link3,
                  "social":social3
                })
            }
            if(link4 !=='' && social4 !==null ){
              socialMedia.push({
                  "link":link4,
                  "social":social4
                })
            }
            if(link5 !=='' && social5 !==null ){
              socialMedia.push({
                  "link":link5,
                  "social":social5
                })
            }
            if(link6 !=='' && social6 !==null ){
              socialMedia.push({
                  "link":link6,
                  "social":social6
                })
            }
            if(socialMedia.length > 0){
                data.append('socialMedia',JSON.stringify(socialMedia))
            }
            console.log(Array.from(data))
            axios.put(`${BASE_END_POINT}about/${this.state.about.id}`,data,{
            headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization':`Bearer ${this.props.currentUser.token}`,
            'Accept-Language':this.props.isRTL?'ar':'en'
            },
            })
            .then(response=>{
            console.log("about UPDATED  ",response.data)
            l.then(() => message.success(allStrings.done, 2.5) )
            this.props.history.goBack() 
            })
            .catch(error=>{
                console.log(error.response)
                l.then(() => message.error(error.response.data.errors.msg[0].msg, 2.5))
            })
        }
    }
    /**
     * upload file
    */
    fileChangedHandler = event => {
      this.setState({
        img: event.target.files[0],
        imgName: event.target.files[0].name,
        imgType:"data"
      })
    }
    /**
     * remove file
    */
    removeFile = () => {
      this.setState({
          img:null,
          imgName:'',
          imgType:"url"
      });
    }
   
    /**
     * form submit Handler
    */
    submitHandler = event => {
        event.preventDefault();
        console.log(event.target.className)
        event.target.className += " was-validated";
        this.update()
    };
    /**
     * form inputs Handler
    */
    changeHandler = event => {
        this.setState({ [event.target.name]: event.target.value });
    };
   
  render(){
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('ABOUT')) return <Redirect to='/Home' />

    return (
    <div className="App">
      <Spin spinning={this.state.loading} tip={allStrings.loading} size="large" style={{color:'#117183'}}>
        <MDBContainer> 
            <MDBRow>  
                <MDBCol md="12">
                    <div className="infoCard">
                        <Card className="editCard" style={{overflow: 'visible',outline:'none',marginBottom:'0px'}}>
                        <CardMedia
                        style={{height:"0px"}}
                        />
                        <CardHeader></CardHeader>
                        <div style={{flexDirection: this.props.isRTL?'row-reverse':'row',display: 'flex'}}>
                            <div className="topIcon" style={{background:'#117183'}}>
                                <span className="material-icons" style={{color:'white',fontSize:23}}>info</span>
                            </div>
                            <div className="tableTitle" style={{display:this.props.isRTL?'inline-block':'inline-block',marginTop:this.props.isRTL?'-60px':'-60px',
                            marginLeft:this.props.isRTL?'0':'0rem',marginRight:this.props.isRTL?'0rem':'0'}}>
                            <p>{allStrings.about}</p>
                            </div>
                        </div>
                        <CardContent style={{minHeight:"390px",outline:'none'}}>
                        <MDBContainer>
                            
                            <MDBRow>
                              <MDBCol md="12">
                              <form
                              className="needs-validation"
                              onSubmit={this.submitHandler}
                              noValidate
                              >
                                  
                                  <div className="grey-text">
                                  
                                  <MDBRow>
                                    <MDBCol md="12">
                                      <div className="md-form">
                                        <label htmlFor="form920" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.aboutUs_en}</label>
                                        <br></br>
                                        <textarea rows="5" onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z0-9\s]/g,'') }  name="aboutUs_en"  style={{minHeight: '200px',border:'none',borderBottom:'1px solid #dededede',direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center',padding:'.3rem 7px .4rem 7px'}} type="text" id="form920" className="form-control" required validate  onChange={this.changeHandler} defaultValue={this.state.about.aboutUs_en?this.state.about.aboutUs_en:""} />
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                    </MDBCol>
                                  </MDBRow>
                                  <MDBRow>
                                    <MDBCol md="12">
                                      <div className="md-form">
                                        <label htmlFor="form90" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.aboutUs_ar}</label>
                                        <br></br>
                                        <textarea rows="5" onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/^[A-Za-z0-9 ]+$/g,'') } name="aboutUs_ar"  
                                        style={{minHeight: '200px',border:'none',borderBottom:'1px solid #dededede',direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center',padding:'.3rem 7px .4rem 7px'}} 
                                        type="text" id="form90" className="form-control" required validate onChange={this.changeHandler}  defaultValue={this.state.about.aboutUs_ar?this.state.about.aboutUs_ar:""} />
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                    </MDBCol>
                                  </MDBRow>
                                  <MDBRow>
                                    <MDBCol md="12">
                                      <div className="md-form">
                                        <label htmlFor="form90" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.newFeatures}</label>
                                        <br></br>
                                        <textarea rows="5"  name="newFeatures"  style={{minHeight: '200px',border:'none',borderBottom:'1px solid #dededede',direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center',padding:'.3rem 7px .4rem 7px'}} type="text" id="form90" className="form-control" required validate onChange={this.changeHandler}  defaultValue={this.state.about.newFeatures?this.state.about.newFeatures:""} />
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                    </MDBCol>
                                  </MDBRow>
                                  {this.state.inputCount > 0&&
                                  <MDBRow>
                                    
                                    <MDBCol md="1">
                                    {this.state.inputCount === 1 &&
                                    <div className="minusInput" onClick={()=>this.setState({inputCount:this.state.inputCount - 1,social1:null})}>
                                      <MDBIcon icon="trash" className="mr-2" />           
                                    </div>
                                    }
                                    </MDBCol>
                                    <MDBCol md="5">
                                      <div className="md-form">
                                        <label htmlFor="form2" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.link}</label>
                                        <input disabled={this.state.actionType==="VIEW"?true:false}  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.link1} type="text" id="form2" name="link1" className="form-control" onChange={this.changeHandler} required validate/>
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                      
                                    </MDBCol>
                                    
                                    <MDBCol md="6">
                                      <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.social}</label>
                                      <TreeSelect 
                                          virtual={false}
                                          showSearch={true} 
                                          maxTagCount="6"
                                          value={this.state.social1}
                                          disabled={this.state.actionType==="VIEW"?true:false}
                                          style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',minHeight:'35px',marginBottom:'1rem'}} 
                                          treeCheckable = {false}        
                                          showCheckedStrategy= {SHOW_PARENT}   
                                          treeNodeFilterProp="title"                      
                                          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                          placeholder={allStrings.social}
                                          onChange={(value) => {
                                          console.log(value)
                                            this.setState({social1:value});
                                            
                                          }} 
                                      
                                      >
                                          
                                          {this.state.socials.map(val=>(
                                              <TreeNode value={val.id} title={val.name} key={val.id} />
                                          ))}
                                      </TreeSelect>
                                    </MDBCol>
                                  </MDBRow>
                                  }
                                  {this.state.inputCount > 1&&
                                  <MDBRow>
                                    <MDBCol md="1">
                                    {this.state.inputCount === 2 &&
                                    <div className="minusInput" onClick={()=>this.setState({inputCount:this.state.inputCount - 1,social2:null})}>
                                      <MDBIcon icon="trash" className="mr-2" />           
                                    </div>
                                    }
                                    </MDBCol>
                                    <MDBCol md="5">
                                      <div className="md-form">
                                        <label htmlFor="form2" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.link}</label>
                                        <input disabled={this.state.actionType==="VIEW"?true:false}  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.link2} type="text" id="form2" name="link2" className="form-control" onChange={this.changeHandler} required validate/>
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                      <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.social}</label>
                                      <TreeSelect 
                                          virtual={false}
                                          showSearch={true} 
                                          maxTagCount="6"
                                          value={this.state.social2}
                                          disabled={this.state.actionType==="VIEW"?true:false}
                                          style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',minHeight:'35px',marginBottom:'1rem'}} 
                                          treeCheckable = {false}        
                                          showCheckedStrategy= {SHOW_PARENT}   
                                          treeNodeFilterProp="title"                      
                                          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                          placeholder={allStrings.social}
                                          onChange={(value) => {
                                          console.log(value)
                                            this.setState({social2:value});
                                            
                                          }} 
                                      
                                      >
                                          
                                          {this.state.socials.map(val=>(
                                              <TreeNode value={val.id} title={val.name} key={val.id} />
                                          ))}
                                      </TreeSelect>
                                    </MDBCol>
                                  </MDBRow>
                                  }
                                  {this.state.inputCount > 2&&
                                  <MDBRow>
                                    <MDBCol md="1">
                                    {this.state.inputCount === 3 &&
                                    <div className="minusInput" onClick={()=>this.setState({inputCount:this.state.inputCount - 1,social3:null})}>
                                      <MDBIcon icon="trash" className="mr-2" />           
                                    </div>
                                    }
                                    </MDBCol>
                                    <MDBCol md="5">
                                      <div className="md-form">
                                        <label htmlFor="form2" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.link}</label>
                                        <input disabled={this.state.actionType==="VIEW"?true:false}  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.link3} type="text" id="form2" name="link3" className="form-control" onChange={this.changeHandler} required validate/>
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                      <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.social}</label>
                                      <TreeSelect 
                                          virtual={false}
                                          showSearch={true} 
                                          maxTagCount="6"
                                          value={this.state.social3}
                                          disabled={this.state.actionType==="VIEW"?true:false}
                                          style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',minHeight:'35px',marginBottom:'1rem'}} 
                                          treeCheckable = {false}        
                                          showCheckedStrategy= {SHOW_PARENT}   
                                          treeNodeFilterProp="title"                      
                                          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                          placeholder={allStrings.social}
                                          onChange={(value) => {
                                          console.log(value)
                                            this.setState({social3:value});
                                            
                                          }} 
                                      
                                      >
                                          
                                          {this.state.socials.map(val=>(
                                              <TreeNode value={val.id} title={val.name} key={val.id} />
                                          ))}
                                      </TreeSelect>
                                    </MDBCol>
                                  </MDBRow>
                                  }
                                  {this.state.inputCount > 3 &&
                                  <MDBRow>
                                    <MDBCol md="1">
                                    {this.state.inputCount === 4 &&
                                    <div className="minusInput" onClick={()=>this.setState({inputCount:this.state.inputCount - 1,social4:null})}>
                                      <MDBIcon icon="trash" className="mr-2" />           
                                    </div>
                                    }
                                    </MDBCol>
                                    <MDBCol md="5">
                                      <div className="md-form">
                                        <label htmlFor="form2" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.link}</label>
                                        <input disabled={this.state.actionType==="VIEW"?true:false}  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.link4} type="text" id="form2" name="link4" className="form-control" onChange={this.changeHandler} required validate/>
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                      <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.social}</label>
                                      <TreeSelect 
                                          virtual={false}
                                          showSearch={true} 
                                          maxTagCount="6"
                                          value={this.state.social4}
                                          disabled={this.state.actionType==="VIEW"?true:false}
                                          style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',minHeight:'35px',marginBottom:'1rem'}} 
                                          treeCheckable = {false}        
                                          showCheckedStrategy= {SHOW_PARENT}   
                                          treeNodeFilterProp="title"                      
                                          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                          placeholder={allStrings.social}
                                          onChange={(value) => {
                                          console.log(value)
                                            this.setState({social4:value});
                                            
                                          }} 
                                      
                                      >
                                          
                                          {this.state.socials.map(val=>(
                                              <TreeNode value={val.id} title={val.name} key={val.id} />
                                          ))}
                                      </TreeSelect>
                                    </MDBCol>
                                  </MDBRow>
                                  }
                                  {this.state.inputCount > 4&&
                                  <MDBRow>
                                    <MDBCol md="1">
                                    {this.state.inputCount === 5 &&
                                    <div className="minusInput" onClick={()=>this.setState({inputCount:this.state.inputCount - 1,social5:null})}>
                                      <MDBIcon icon="trash" className="mr-2" />           
                                    </div>
                                    }
                                    </MDBCol>
                                    <MDBCol md="5">
                                      <div className="md-form">
                                        <label htmlFor="form2" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.link}</label>
                                        <input disabled={this.state.actionType==="VIEW"?true:false}  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.link5} type="text" id="form2" name="link5" className="form-control" onChange={this.changeHandler} required validate/>
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                      <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.social}</label>
                                      <TreeSelect 
                                          virtual={false}
                                          showSearch={true} 
                                          maxTagCount="6"
                                          value={this.state.social5}
                                          disabled={this.state.actionType==="VIEW"?true:false}
                                          style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',minHeight:'35px',marginBottom:'1rem'}} 
                                          treeCheckable = {false}        
                                          showCheckedStrategy= {SHOW_PARENT}   
                                          treeNodeFilterProp="title"                      
                                          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                          placeholder={allStrings.social}
                                          onChange={(value) => {
                                          console.log(value)
                                            this.setState({social5:value});
                                            
                                          }} 
                                      
                                      >
                                          
                                          {this.state.socials.map(val=>(
                                              <TreeNode value={val.id} title={val.name} key={val.id} />
                                          ))}
                                      </TreeSelect>
                                    </MDBCol>
                                  </MDBRow>
                                  }
                                  {this.state.inputCount > 5&&
                                  <MDBRow>
                                    <MDBCol md="1">
                                    {this.state.inputCount === 6 &&
                                    <div className="minusInput" onClick={()=>this.setState({inputCount:this.state.inputCount - 1,social6:null})}>
                                      <MDBIcon icon="trash" className="mr-2" />           
                                    </div>
                                    }
                                    </MDBCol>
                                    <MDBCol md="5">
                                      <div className="md-form">
                                        <label htmlFor="form2" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.link}</label>
                                        <input disabled={this.state.actionType==="VIEW"?true:false}  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.link6} type="text" id="form2" name="link6" className="form-control" onChange={this.changeHandler} required validate/>
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                      <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.social}</label>
                                      <TreeSelect 
                                          virtual={false}
                                          showSearch={true} 
                                          maxTagCount="6"
                                          value={this.state.social6}
                                          disabled={this.state.actionType==="VIEW"?true:false}
                                          style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',minHeight:'35px',marginBottom:'1rem'}} 
                                          treeCheckable = {false}        
                                          showCheckedStrategy= {SHOW_PARENT}   
                                          treeNodeFilterProp="title"                      
                                          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                          placeholder={allStrings.social}
                                          onChange={(value) => {
                                          console.log(value)
                                            this.setState({social6:value});
                                            
                                          }} 
                                      
                                      >
                                          
                                          {this.state.socials.map(val=>(
                                              <TreeNode value={val.id} title={val.name} key={val.id} />
                                          ))}
                                      </TreeSelect>
                                    </MDBCol>
                                  </MDBRow>
                                  }{this.state.inputCount < 6 &&
                                  this.state.actionType==="EDIT"?
                                  <MDBRow>
                                     <div className="addInput" onClick={()=>this.setState({inputCount:this.state.inputCount + 1})}>
                                      <MDBIcon icon="plus" className="mr-2" />           
                                    </div>
                                  </MDBRow>
                                  :
                                  <MDBRow></MDBRow>
                                  }
                                  <MDBRow>
                                        <MDBCol md="12">
                                        <label htmlFor="form830" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.logo}</label>

                                            <div className="fileUpload2"> 
                                                <input  key={this.state.img} type='file' className="upImgs2" onChange={this.fileChangedHandler} ></input>
                                                <span className="uploadParent"><UploadOutlined style={{color: '#000',fontSize: '14px',position: 'relative',top: '-3px',marginRight: '2px'}}/><span className="uploadName">{allStrings.upload}</span></span>
                                            </div>
                                            <div className="preview">
                                            {this.state.img&&
                                            <div style={{display:"inline-block",width: '100%',border: '1px solid mediumaquamarine'}}>
                                                <img alt="" src={this.state.imgType==="data"?URL.createObjectURL(this.state.img):this.state.img} className="previewImg2"/>
                                                <span className="imgName">{this.state.imgName}</span>
                                                <MDBIcon icon="trash" className="mr-2 removeImg3"
                                                onClick={() => this.removeFile()}  ></MDBIcon>
                                            </div>
                                            }
                                            </div>
                                            
                                        </MDBCol>
                                      
                                  </MDBRow>
                                  </div>
                                  <br></br>
                                  <br></br>
                                  <div className="text-center">
                                      <MDBBtn
                                      type="submit" style={{background:'#117183'}}
                                      rounded
                                      className="btn-block z-depth-1a"
                                      >
                                      <MDBIcon icon="edit" className="mr-2" />
                                          {allStrings.edit}          
                                      </MDBBtn>
                                      
                                  </div>
                              </form>
                              </MDBCol>
                            </MDBRow>
                        </MDBContainer>
                        </CardContent>
                    </Card>
                </div>
            </MDBCol>
            </MDBRow>
      </MDBContainer>
      </Spin>
    </div> 
  )
  }
}


const mapToStateProps = (state) => ({
    isRTL: state.lang.isRTL,
    currentUser: state.auth.currentUser,
  });
  
  const mapDispatchToProps = {
  };
  
  export default withRouter(
    connect(mapToStateProps, mapDispatchToProps)(About)
  );